import { Flex, Text } from '@podiumhq/design-system';

const boxStyles = {
  // display: 'flex',
  // flexDirection: 'row',
  alignItems: 'center',
  padding: '16px',
  marginBottom: '24px',

  background: 'black.lightest',
  borderRadius: '12px',

  fontStyle: 'normal',
};

const TrialAccountInviteExistsMessage = ({ display, businessName, ...props }) =>
  display ? (
    <Flex {...boxStyles} {...props}>
      <Text color="#FFFFFF" fontSize="md" fontWeight="normal" lineHeight="20px">
        Looks like you were invited to an existing Podium account. Are you sure
        you want to start a free trial?{' '}
        <span style={{ textDecoration: 'underline' }}>
          Check your email for an invitation to join {businessName}.
        </span>
      </Text>
    </Flex>
  ) : (
    <></>
  );

export default TrialAccountInviteExistsMessage;
